import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { getDocumentInitials } from '../constants/documentTheme';
import { isUsableImageUrl } from '../utils/itineraryItemImage';

const initialsForPartner = (partner, initialsFrom) => {
  if (initialsFrom === 'contact') {
    return partner?.contact_name || partner?.email || partner?.company_name;
  }
  return partner?.company_name;
};

const PartnerLogoMark = ({
  partner,
  src: srcProp,
  alt = '',
  sx = {},
  hideOnError = false,
  /** 'company' for brand marks; 'contact' for the logged-in person in chrome. */
  initialsFrom = 'company',
  /** When true, never show the company logo — only contact/company initials. */
  initialsOnly = false,
}) => {
  const [failed, setFailed] = useState(false);
  const imageUrl = srcProp !== undefined ? srcProp : partner?.logo;
  const src = !initialsOnly && isUsableImageUrl(imageUrl)
    ? String(imageUrl).trim()
    : '';
  const showImage = Boolean(src) && !failed;

  useEffect(() => {
    setFailed(false);
  }, [imageUrl, initialsOnly]);

  if (!showImage && hideOnError) return null;

  return (
    <Box
      component={showImage ? 'img' : 'div'}
      src={showImage ? src : undefined}
      alt={showImage ? alt : undefined}
      data-testid="partner-logo-mark"
      onError={showImage ? () => setFailed(true) : undefined}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        objectFit: 'contain',
        objectPosition: 'left center',
        ...sx,
      }}
    >
      {!showImage ? getDocumentInitials(initialsForPartner(partner, initialsFrom)) : null}
    </Box>
  );
};

export default PartnerLogoMark;
